import { render, staticRenderFns } from "./edit-address.vue?vue&type=template&id=6a37bbee&scoped=true"
import script from "./edit-address.vue?vue&type=script&lang=js"
export * from "./edit-address.vue?vue&type=script&lang=js"
import style0 from "./edit-address.vue?vue&type=style&index=0&id=6a37bbee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a37bbee",
  null
  
)

export default component.exports